import { v4 as uuidv4 } from 'uuid'
import { PatientMatching } from "./PatientMatching";
import { SampleMatching } from "../../../sampleType/models/sampleForm/SampleMatching";
import { emptySampleMatchingDTO } from "../../../sampleType/models/sampleForm/SampleMatchingDTO";

export interface PatientMatchingDTO {
    _id: string | undefined;
    _firstName: string;
    _lastName: string;
    _dob: Date;
    _bioarrayCode: string;
    _nhcOrDni: string;
    _province: string
    _zipCode: string
    _phone: string;
    _email: string;
    _indication: string
    _clinicHistory: string
    _sample: SampleMatching
    _sex: string
    _genes: string
    _panelSelected: number
    _external: boolean
}

export function emptyPatientMatchingDTO(): PatientMatchingDTO {
    return {
        _id: uuidv4(),
        _firstName: '',
        _lastName: '',
        _dob: new Date(),
        _nhcOrDni: '',
        _province: '',
        _bioarrayCode: '',
        _zipCode: '',
        _phone: '',
        _email: '',
        _indication: '',
        _clinicHistory: '',
        _sample: new SampleMatching(emptySampleMatchingDTO()),
        _sex: "0",
        _genes: '',
        _panelSelected: 0,
        _external: false
    }
}

export function fromPatientMatchingModel(c: PatientMatching): PatientMatchingDTO {
    return {
        _id: c.id,
        _firstName: c.firstName,
        _lastName: c.lastName,
        _dob: c.dob,
        _nhcOrDni: c._nhcOrDni,
        _bioarrayCode: c._bioarrayCode,
        _province: c.province,
        _zipCode: c.zipCode,
        _phone: c.phone,
        _email: c.email,
        _indication: c.indication,
        _clinicHistory: c.clinicHistory,
        _sample: c.sample,
        _sex: c.sex,
        _genes: c.genes,
        _panelSelected: c._panelSelected,
        _external: c._external
    }
}

export function toModelPatientMatching(c: PatientMatchingDTO): PatientMatching {
    return new PatientMatching(c)
}

export function toModelPatientMatchingList(c: PatientMatchingDTO[]): PatientMatching[] {
    let list: PatientMatching[] = []
    c?.forEach((p) => {
        list.push(new PatientMatching(p))
    })

    return list
}